import { render, staticRenderFns } from "./sensorsidebar.vue?vue&type=template&id=1770061a&scoped=true&"
import script from "./sensorsidebar.vue?vue&type=script&lang=js&"
export * from "./sensorsidebar.vue?vue&type=script&lang=js&"
import style0 from "./sensorsidebar.vue?vue&type=style&index=0&id=1770061a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770061a",
  null
  
)

export default component.exports